"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOlarkTracking = void 0;
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_chat_utils_1 = require("./fdr-chat.utils");
// @todo: find other way to manage subscriptions
let isOlarkTrackingActive;
const useOlarkTracking = () => {
    (0, libs_hooks_react_1.useIsomorphicLayoutEffect)(() => {
        if (!window || !window.olark || isOlarkTrackingActive)
            return;
        fdr_chat_utils_1.trackingChatEvents.map(([event, action]) => {
            window.olark(event, () => {
                window.duckTape.push({
                    event: '🚀 olark_chat',
                    eventMetadata: { action },
                    _clear: true,
                });
            });
        });
        isOlarkTrackingActive = true;
    });
};
exports.useOlarkTracking = useOlarkTracking;
//# sourceMappingURL=useOlarkTracking.js.map